import { campaignTagsEnum } from "../types/placement"
import { placementsEnum } from "../types/types"

export const PLACEMENTS_COUNT = 5

export const COLORS_BY_TAG: Record<campaignTagsEnum, string> = {
  [campaignTagsEnum.RANKING]: "green",
}

export const PLACEMENT_ROW_ORDER: placementsEnum[] = [
  placementsEnum.TOP_OF_SEARCH,
  placementsEnum.REST_OF_SEARCH,
  placementsEnum.PRODUCT_PAGE,
  placementsEnum.AMAZON_BUSINESS,
  placementsEnum.TOP_OF_BROWSE,
  placementsEnum.REST_OF_BROWSE,
  placementsEnum.FEATURED_VIDEOS,
  placementsEnum.AUDIENCE,
]

export const BROWSE_PLACEMENTS: placementsEnum[] = [
  placementsEnum.TOP_OF_BROWSE,
  placementsEnum.REST_OF_BROWSE,
]

export const BROWSE_METRICS_NOTE = "Amazon does not yet report browse placement performance"

export const PLACEMENT_MODIFIER_MIN = 0

export const PLACEMENT_MODIFIER_MAX = 900
